import { Row } from '@tanstack/react-table';
import { DateRangeFilterValue } from '@components/primitives/dataGrid/components/filters/DateRangeFilter';

const dateRangeFilter = <TData extends object>(row: Row<TData>, columnId: string, value: DateRangeFilterValue) => {
    const rowValue = row.getValue(columnId) as string;
    const rowValueDate = rowValue && rowValue.split('T') ? rowValue.split('T')[0] : null;

    const rowValueTimeStamp = rowValueDate ? new Date(rowValueDate).getTime() : null;
    const [start, end] = value ?? [];

    if (!rowValueTimeStamp) {
        return false;
    }

    // Only start date selected
    if (start && !end) {
        return rowValueTimeStamp >= start;
    }

    // Only end date selected
    if (!start && end) {
        return rowValueTimeStamp <= end;
    }

    // Both dates selected
    if (start && end) {
        return rowValueTimeStamp >= start && rowValueTimeStamp <= end;
    }

    return true;
};

export default dateRangeFilter;
